var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{ref:"contractors-table",attrs:{"title":_vm.title,"url":"/contractors","fields":_vm.fields,"table-ref":"contractors-table","detail-component":"contractor-detail-row"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }